import { useCallback, useEffect, useState } from "react";

import { AccordionItemType } from "../Accordion.types";

type Props = {
  items: AccordionItemType[];
  multipleExpand?: boolean;
  onClick?: () => void;
};

const useManageAccordion = ({ items, multipleExpand, onClick }: Props) => {
  const [itemsState, setItemsState] = useState<Record<string, boolean>>({});

  const handleItemClick = useCallback(
    (id: string) => {
      let newItemsState;
      if (!multipleExpand) {
        newItemsState = { ...itemsState };

        Object.keys(itemsState).forEach((key) => {
          if (key === id) {
            newItemsState[key] = !itemsState[id];
          } else {
            newItemsState[key] = false;
          }
        });
      } else {
        newItemsState = { ...itemsState, [id]: !itemsState[id] };
      }

      setItemsState(newItemsState);

      onClick && onClick();
    },
    [itemsState, multipleExpand, onClick]
  );

  useEffect(() => {
    setItemsState((state) => {
      const newState = { ...state };

      items.forEach((item) => {
        if (!Object.prototype.hasOwnProperty.call(newState, item.id)) {
          newState[item.id] = !item.collapsed;
        }
      });

      return newState;
    });
  }, [items]);

  return {
    handleItemClick,
    itemsState,
  };
};

export default useManageAccordion;
